import { isLocalhost } from './isLocalhost';

/**
 * `?local_profile_preview=1` on localhost shows locals without a face picture,
 * so the Local's profile can be tested against content that has no pictures yet.
 */
export const isLocalProfilePreview = (): boolean =>
  isLocalhost() && new URLSearchParams(window.location.search).get('local_profile_preview') === '1';
